import React from 'react';
import './Skeleton.css';

/**
 * Atomic Skeleton component for building loading states
 * @param {string} variant - 'text', 'circle', 'rect'
 * @param {string|number} width - CSS width
 * @param {string|number} height - CSS height
 * @param {string} className - Additional CSS classes
 */
const Skeleton = ({ 
    variant = 'text', 
    width, 
    height, 
    className = '',
    style = {}
}) => {
    const styles = {
        width,
        height,
        ...style
    };

    return (
        <div 
            className={`skeleton-base skeleton-${variant} ${className}`} 
            style={styles}
        />
    );
};

export default Skeleton;
